import { Form, Row, Col, Tabs, notification } from "antd";
import React from "react";

import { LightBlueContainer } from "../../styled/Container.styled";
import { PrimaryButton } from "../../styled/Button.styled";

import OffersForm from "./OffersDetailsForm";
import OffersTerms from "./offersTerms";
import { useAddOfferMutation } from "../../../feature/Offer/offerApiSlice";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { useState } from "react";
const AddOffers = () => {
  const [addOffer] = useAddOfferMutation();
  const navigate = useNavigate();
  const [imgFile, setImgFile] = useState("");
  const [activeTab, setActiveTab] = useState("1");
  const offerDetailsFormRef = React.useRef<any>(null);
  // Stops a double click / repeated submit event from saving the same offer twice.
  const isSavingRef = React.useRef(false);
  
  const handleTabChange = (key: any) => {
    setActiveTab(key);
  };

  const handleNextClick = () => {
    // Validate the offer details form before proceeding
    if (offerDetailsFormRef.current) {
      offerDetailsFormRef.current.validateFields()
        .then(() => {
          // Validation passed, move to next tab
          setActiveTab("2");
        })
        .catch((error: any) => {
          // Validation failed, show error notification
          notification.error({
            message: "Validation Error",
            description:
              error?.errorFields?.[0]?.errors?.[0] || "Please fill all required fields before proceeding.",
            placement: "bottomLeft",
          });
        });
    }
  };
  const tabItems = [
    {
      label: "Details",
      key: "1",
      children: <OffersForm setImgFile={setImgFile} formRef={offerDetailsFormRef} />,
    },
    {
      label: "Terms And Condition",
      key: "2",
      children: <OffersTerms />,
    },
  ];
  return (
    <>
      <Form.Provider
        onFormFinish={(name, { forms }) => {
          if (name === "submitForm") {
            const { offerDetailsForm, offerTermsForm } = forms;
            offerDetailsForm.submit();
            offerTermsForm.submit();

            let offerData = { ...offerDetailsForm.getFieldsValue() };
            let terms = { ...offerTermsForm.getFieldsValue() };

            let obj = {
              ...offerData,
              // Codes are saved in capitals with no spaces, so they match whatever the rider types.
              couponCode: (offerData.couponCode || "").replace(/\s/g, "").toUpperCase(),
              liveDate: dayjs(offerData.liveDate).toISOString(),
              liveTime: offerData.liveTime ? dayjs(offerData.liveTime).format('HH:mm:ss') : null,
              expireDate: dayjs(offerData.expireDate).toISOString(),
              expireTime: offerData.expireTime ? dayjs(offerData.expireTime).format('HH:mm:ss') : null,
              image: imgFile,
              offerStatus: "ACTIVE",
              status: true,
              termsAndConditions: Object.values((terms))[0],
              // The app finds offers by the trip type it is booking, so ALL is saved as every type.
              offerTripTypes: (offerData.offerTripTypes || []).includes("ALL")
                ? ["LOCAL", "OUTSTATION", "RENTAL"]
                : offerData.offerTripTypes,
            };

            if (isSavingRef.current) return;
            isSavingRef.current = true;

            addOffer(obj)
              .unwrap()
              .then((res: any) => {
                notification.success({
                  message: "Successfully Added!",
                  placement: "bottomLeft",
                });
                navigate(-1);
              }).catch((error) => {
                isSavingRef.current = false;
                notification.error({
                  message: "Error!",
                  description: error.data.message,
                  placement: "bottomLeft",
                });
              });
          }
        }}
      >
        <Row justify="end" gutter={20} className="button-bottom-margin">
          <Col style={{ display: "flex" }}>
            {
              activeTab === "1" ? <PrimaryButton onClick={handleNextClick}>Next</PrimaryButton> :
                <Form name="submitForm" style={{ marginLeft: "10px" }}>
                  <PrimaryButton htmlType="submit">Save</PrimaryButton>
                </Form>

            }
          </Col>
        </Row>
        <LightBlueContainer>
          <Tabs defaultActiveKey={activeTab} activeKey={activeTab} items={tabItems} onChange={handleTabChange} />
        </LightBlueContainer>
      </Form.Provider>
    </>
  );
          };
export default AddOffers;
